// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qayf","right":"styles_right__37Vnc"};